module.exports = __webpack_public_path__ + "static/img/desktop-gdtj.7f0e6984.png";